import {iFrameMerchantService} from "../../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../../blink-sdk/Constants";
import {PaymentFailedIcon} from "../../../../../SVGElements";
import {Messages} from "../../../../../Messages";
import {Link} from "../../../../../../stem-core/src/ui/UIPrimitives";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {Router} from "../../../../../../stem-core/src/ui/Router";
import {INLINE_SUBSCRIPTION_URLS} from "../../../../PanelConstants";
import {giftSubscriptionFlowState} from "../../../../inline-subscription/GiftSubscriptionFlowState";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {DonationFailedPanelStyle} from "../../donation/DonationFailedPanel";
import {BasePanelPage} from "../../BasePanelPage";
import {paymentMethodController} from "../../../../inline-donation/PaymentMethodController";


// TODO: Merge all of these classes and use the paymentMethodController only (add a retry method and such).
@registerStyle(DonationFailedPanelStyle)
export class GiftSubscriptionFailedPanel extends BasePanelPage {
    formatPaymentErrorMessage(message) {
        let formattedMessage = (message || "").toString().trim();

        if (!formattedMessage.length) {
            return formattedMessage;
        }

        if (formattedMessage.slice(-1) !== ".") {
            formattedMessage += ".";
        }

        formattedMessage += " ";

        return formattedMessage;
    }

    render() {
        const {styleSheet} = this;

        return [
            iFrameMerchantService.isMerchant(TNR_ALIAS) ? null :
                <PaymentFailedIcon className={styleSheet.icon} color={this.styleSheet.themeProps.MERCHANT_TEXT_SECONDARY_COLOR}/>,
            <div testId="subscribeFailedTitle"
                 className={styleSheet.title + (iFrameMerchantService.isMerchant(TNR_ALIAS) ? styleSheet.leftAlign : "")}>
                {Messages.subscribePaymentFailedModal}</div>,
            <div testId="subscribeFailedMessage" className={styleSheet.message}>
                {paymentMethodController.isCDSPaymentError() && iFrameMerchantService.isMerchant(TNR_ALIAS) ?
                    [Messages.tnrContactCustomerSupport, <Link className={styleSheet.link} value={Messages.tnrContactCustomerSupportLink} href={Messages.tnrCustomerSupportLink.toString()}/>, "."] :
                    [this.formatPaymentErrorMessage(paymentMethodController.getPaymentErrorMessage()), Messages.subscribeFailedMessage]}
            </div>,
            <MerchantButton className={styleSheet.button}
                            onClick={() => Router.changeURL(INLINE_SUBSCRIPTION_URLS.paymentDetails)}>
                {Messages.editPaymentDetails}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <div className={styleSheet.secondaryButton}
                     onClick={() => giftSubscriptionFlowState.giftSubscription()}>
                    {Messages.retryPaymentSubscribe}
                </div>
            </div>,
        ];
    }

    onMount() {
        super.onMount();

        this.attachListener(paymentMethodController, () => this.redraw());
    }
}
